<template>
  <div class="informations-contract">
    <div class="contract-details">
      <hr>
      <div class="row">
        <div class="col-md-4 left-row">
          <img v-if="isFetched && imagePathOf !== false" :src="imagePathOf" height="300px"  style="max-width:100%"/>
        </div>
        <div class="col-md-8">
          <ul class="contract-address">
            <li>
              <i class="circle" :class="classDependingOnContractStatus"></i>
              {{contract.decoded_type}} {{contract.organization_display_name}}
              <a v-if="!contract.completed"
                :href="completeButtonUrl" 
                tag="button" 
                class="btn btn-default btn-sm" 
                target="_blank" 
              >
                <span>Compléter</span>
              </a>
              <router-link v-if="contract.validated"
                :to="routerLink" 
                tag="button" 
                class="btn btn-default btn-sm">Gérer</router-link>
            </li>
            <li>{{agencyAddressLine}}</li>
            <li style="margin-top: 10px;">Type : {{ contract.decoded_type }}</li>
            <li>Statut : {{ contract.decoded_status }}</li>
            <li v-if="contract.start_date">Date de début : {{ contract.start_date | moment-date }}</li>
            <li v-if="contract.end_date">Date de sortie : {{ contract.end_date | moment-date }}</li>
            <li v-if="contract.order && contract.order.sap_promo_code" style="margin-top: 10px;">
              Code promo : {{ contract.order.sap_promo_code }}
            </li>
          </ul>
          <template v-if="contract.contract_options.length">
            <div class="top-options" v-if="contract.contract_options.length">
              <span>Options :</span>
            </div>
            <ul class="options" v-if="contract.contract_options.length">
              <li v-for="contract_option in contract.contract_options">
                {{decodeOptionLine(contract_option)}}
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>

    <div v-if="contract.start_date == contract.end_date" class="item-overlay"></div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import commonLogic from './commonLogic'

export default {
    mixins: [commonLogic],

    computed: {
        ...mapState("contract", ["fullOffers"]),

        isFetched() {
            return _.find(this.fullOffers, (offer) => offer.id == this.contract.offer.id) != undefined
        },

        imagePathOf() {
            var offer = _.find(this.fullOffers, (offer) => offer.id == this.contract.offer.id)
            if (offer != undefined) {
                var img = _.find(offer.distributed_product.product.images, (image) => image.order_column == 1)
                if (img != undefined)
                    return __API_URL__ + "/photos/" + img.id + "/" + img.file_name
                else
                    return false
            }
        },

        classDependingOnContractStatus () {
          switch (this.contract.status) {
              case 'active':
                return 'green'
                break
              case 'terminated':
                return 'red'
                break
              case 'pending-startup':
                return 'blue'
                break
              case 'pending-termination':
                return 'orange'
                break
          }
      }
    },

    methods: {
        ...mapActions("contract", ["fetchSingleFullOffer"])
    },

    created() {
        this.fetchSingleFullOffer(this.contract.offer.id)
    }
}
</script>

<style lang="scss" scoped>
  .informations-contract {
    position: relative;

    .item-overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.75);
      z-index: 1010;
    }
  }
</style>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Contracts/LongTermLocation.vue